<app-card-table [cards]="cards"
                [tableId]="tableId"
                [columns]="columns"
                [showDragHint]="showDragHint"
                [hideSearch]="hideSearch"
                [totalSize]="resultsLength"
                [isLoadingResults]="isLoadingResults"
                [showOwnedCardsSelector]="showOwnedCardsSelector"
                [isValid]="isValid"
                [removableCards]="removableCards"
                [addCardsToDeck]="addCardsToDeck"
                [addCardsToInventory]="addCardsToInventory"
                [overrideClick]="overrideClick"
                (cardClicked)="cardClicked.emit($event)"
                (cardInputFieldChanged)="cardInputFieldChanged.emit($event)"
                (pagingChanged)="pagingChanged($event)"
                (newQuery)="queryChanged($event)"
                (showOwnedCardsSelectorChanged)="onShowOwnedCardsSelectorChanged($event)"
                (cardActionTaken)="cardActionTaken.emit()">
</app-card-table>
